import React from "react";

// Step 1: context creation
// Step 2: Provider
// Step 3: useContext hook (instead of using Consumer which is lengthy process)

const IRMAppContext = React.createContext();

// create a provider function
const IRMAppProvider = ({children}) => {
    return (
        <IRMAppContext.Provider value = {"app-provider"}>{children}</IRMAppContext.Provider>
    );
}

export { IRMAppContext, IRMAppProvider};